import { render, staticRenderFns } from "./Tabs1.vue?vue&type=template&id=4cb084a6&scoped=true"
import script from "./Tabs1.vue?vue&type=script&lang=js"
export * from "./Tabs1.vue?vue&type=script&lang=js"
import style0 from "./Tabs1.vue?vue&type=style&index=0&id=4cb084a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb084a6",
  null
  
)

export default component.exports